import React from 'react';
import { Link } from 'react-router-dom';
import article from '../assets/article.svg';
import rightArrow from '../assets/arrow-right.svg';
import './article.css';

class Articol extends React.Component {
    render() {
        return (
            <Link to={this.props.to}>
                <div className='article-outer'>
                    <div className={`articol-container mb-1 ${this.props.color === 'blue' ? 'article-blue' : 'article-black'}`}>
                        <img className='article-img' alt={article} src={article} />
                        <img className='link-right-arrow' alt="left-arrow" src={rightArrow} />
                    </div>

                    <div className='article-title'>{this.props.title}</div>
                </div>
            </Link>
        );
    }
}

export default Articol;